module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="form-row">\r\n  <div class="form-group col">\r\n    <label for="famille.code">'+
((__t=(i18n.t("common:selecteuractivites.dlgfamille")))==null?'':__t)+
'</label>\r\n    <span class="selecteurFamille"></span>\r\n  </div>\r\n</div>\r\n';
}
return __p;
};
